/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function Ground24(props) {
  const { nodes, materials } = useGLTF("/YemekTakimiTabak.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={
          nodes["Combine23(0216F9C3-5D53-48E0-8825-5038FED36DBF)-mesh"].geometry
        }
        material={materials["Material_1.003"]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={
          nodes["Combine23(0216F9C3-5D53-48E0-8825-5038FED36DBF)-mesh_1"]
            .geometry
        }
        material={materials["Material_2.004"]}
      />
    </group>
  );
}

useGLTF.preload("/YemekTakimiTabak.glb");
